import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles'
import colors from 'Assets/colors'
import { media } from 'Config/styled'

export const useStyles = makeStyles(() => ({
  button: {
    width: '240px',
    height: '56px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    textAlign: 'center',
    textTransform: 'none',
    color: colors.white,
    transition: 'all 0.2s',
    border: `1px solid ${colors.secondary}`,
    backgroundColor: colors.secondary,
    '&:hover': {
      opacity: 0.8,
      color: colors.white,
      transform: 'translateY(-2px)',
      backgroundColor: colors.secondary,
      boxShadow: '0 3px 5px rgba(51, 51, 51, 0.2)',
    },
    '&:active': {
      transform: 'translate(-1px)',
      boxShadow: '0 1px 3px rgba(51, 51, 51, 0.4)',
    },
  },
}))

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 500px;

  ${media('lg')} {
    width: 100%;
  }
`

export const Content = styled.div`
  background: #ffffff;
  width: 600px;
  align-items: center;
  justify-content: center;
  height: 200px;

  ${media('lg')} {
    width: 100%;
  }
`

export const Title = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.black};
  margin-bottom: 16px;
  text-align: center;
  margin-top: 24px;
`

export const SubTitle = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.black};
  text-align: center;
  margin-top: 24px;
  margin-bottom: 24px;
`
export const RowButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${props => (props.showCancelOrder ? 'space-between' : 'center')};

  ${media('lg')} {
    flex-direction: column;
  }
`

export const NotServedButton = styled.div`
  width: 47%;
  background-color: ${colors.secondary};
  padding: 1rem;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.white};
  border: 2px solid ${colors.secondary};
  border-radius: 8px;
  cursor: pointer;
  align-items: center;
  transition: all 0.2s;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-rightt: 20px;
  margin-left: 20px;

  &:hover {
    opacity: 0.8;
    transform: translateY(-2px);
    box-shadow: 0 3px 5px rgba(51, 51, 51, 0.2);
  }

  &:active {
    transform: translate(-1px);
    box-shadow: 0 1px 3px rgba(51, 51, 51, 0.4);
  }

  &[disabled] {
    pointer-events: none;
    opacity: 0.6;
  }
`

export const CancelButton = styled.div`
  width: 47%;
  background-color: ${colors.white};
  padding: 1rem;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.black};
  border: 2px solid ${colors.black};
  border-radius: 8px;
  cursor: pointer;
  align-items: center;
  transition: all 0.2s;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 20px;
  margin-rightt: 20px;
  &:hover {
    opacity: 0.8;
    transform: translateY(-2px);
    box-shadow: 0 3px 5px rgba(51, 51, 51, 0.2);
  }

  &:active {
    transform: translate(-1px);
    box-shadow: 0 1px 3px rgba(51, 51, 51, 0.4);
  }

  &[disabled] {
    pointer-events: none;
    opacity: 0.6;
  }
`

export const CloseButton = styled.div`
  width: 50%;
  background-color: ${colors.white};
  padding: 1rem;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.secondary};
  border: 2px solid ${colors.secondary};
  border-radius: 8px;
  cursor: pointer;
  align-items: center;
  transition: all 0.2s;
  align-self: center;
  justify-self: center;
  justify-content: center;
  align-content: center;
  margin-top: 20px;

  &:hover {
    opacity: 0.8;
    transform: translateY(-2px);
    box-shadow: 0 3px 5px rgba(51, 51, 51, 0.2);
  }

  &:active {
    transform: translate(-1px);
    box-shadow: 0 1px 3px rgba(51, 51, 51, 0.4);
  }
`
